import Link from '@mui/material/Link';
import Typography from '@mui/material/Typography';

import { usePreAuthAmount } from 'reservations/account/providers/ConfigProvider';
import {
  PRIVACY_POLICY_URL,
  TERMS_OF_SERVICES_URL
} from 'reservations/base/constants/bentobox';

type Props = {
  showPreAuthText?: boolean;
};

const FinePrint = ({ showPreAuthText = false }: Props) => {
  const preAuthAmount = usePreAuthAmount();

  return (
    <Typography sx={{ fontSize: '12px' }} data-testid="fine-print">
      {showPreAuthText &&
        `Please note that your card will be pre-authorized for a flat fee of $${preAuthAmount}.`}
      We use your contact information to send you details about your booking
      and/or communications regarding your experience (via email and/or
      texting). By using this service you are agreeing to our{' '}
      <Link href={TERMS_OF_SERVICES_URL} target="_blank" rel="noopener">
        Terms of Service
      </Link>
      {' and '}
      <Link href={PRIVACY_POLICY_URL} target="_blank" rel="noopener">
        Privacy Policy
      </Link>
      .
    </Typography>
  );
};

export default FinePrint;
